"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("../styles");
const location_1 = require("../../../common/util/location");
const constants_1 = require("../../../common/util/constants");
const MapLink_styles_1 = require("./MapLink.styles");
const MAP_TYPE = {
    DISTANCE: 'Distance',
    MAP: 'Map'
};
const MapLink = ({ distance, location, searchedLocation, track, intl }) => {
    const showLocationWithDistance = searchedLocation && distance;
    const mapLinkAriaLabel = showLocationWithDistance
        ? constants_1.messages.mapDistanceLinkLabel
        : constants_1.messages.maplinklabel;
    const handleClick = track
        ? () => {
            track(constants_1.LOGGING.MESSAGE.MAP_LINK_CLICKED, {
                location_name: location.name,
                map_type: showLocationWithDistance ? MAP_TYPE.DISTANCE : MAP_TYPE.MAP
            });
        }
        : undefined;
    const googleMapValues = (0, location_1.getGoogleMapValues)(location, searchedLocation);
    const message = showLocationWithDistance ? (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.locationDistance, { values: { distance } }))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.maplink)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Separator, { "aria-hidden": true }, "\u2022"),
        react_1.default.createElement(MapLink_styles_1.MapAnchor, { "data-testid": "map-link", onClick: handleClick, href: googleMapValues.href, target: "_blank", "aria-label": intl.formatMessage(mapLinkAriaLabel, {
                location: googleMapValues.locationString,
                distance
            }) }, message)));
};
exports.default = (0, intl_1.injectIntl)(MapLink);
//# sourceMappingURL=MapLink.js.map